export enum BannerType {
  IS_SUCCESS = 'is-success',
  IS_DANGER = 'is-danger',
  IS_WARNING = 'is-warning',
  IS_PRIMARY = 'is-primary',
  IS_DISABLED = 'is-disabled',
  IS_TERTIARY = 'is-tertiary'
}
